import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-access-info',
  templateUrl: './access-info.component.html',
  styleUrls: ['./access-info.component.css']
})
export class AccessInfoComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public itemsListSubscriptions: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(2621, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadSubscriptions() {
        if (!this.setting) return;

        return this.itemsListSubscriptions = await this.datatask.Post(2622, this.setting);
    }

    private async init() {
        await this.loadSetting();
        this.loadSubscriptions();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    argtype: string;
    argvalue: string;
    page_heading: string;
}
